import { useState } from 'react';

export function useDateRange() {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const dateParams = () => {
    const p = {};
    if (dateFrom) p.date_from = dateFrom;
    if (dateTo) p.date_to = dateTo;
    return p;
  };

  const clearDates = () => {
    setDateFrom('');
    setDateTo('');
  };

  return { dateFrom, dateTo, setDateFrom, setDateTo, dateParams, clearDates };
}
